import React from 'react';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  type Theme,
} from '@mui/material';

type MobileNavDrawerProps = {
  openDrawer: boolean;
  setOpenDrawer: (value: boolean) => void;
  theme: Theme;
  pages: { name: string; path: string; icon: React.ElementType }[];
  navigate: (path: string) => void;
};

export const MobileMenuNavDrawer = (props: MobileNavDrawerProps) => {
  return (
    <Drawer
      sx={{
        width: 240,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: 240,
          boxSizing: 'border-box',
        },
      }}
      variant="persistent"
      anchor="left"
      open={props.openDrawer}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          height: '56px',
        }}
      >
        <IconButton
          data-testid={props.theme.direction === 'ltr' ? 'chevron-left-button' : 'chevron-right-button'}
          aria-label={props.theme.direction === 'ltr' ? 'Close Menu' : 'Open Menu'}
          onClick={() => {
            props.setOpenDrawer(false);
          }}
          sx={{ display: 'flex', justifyContent: 'flex-end', width: '40px' }}
        >
          {props.theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </Box>
      <Divider />
      <List>
        {props.pages.map((page) => (
          <ListItem key={page.name} disablePadding>
            <ListItemButton
              onClick={() => {
                (props.navigate(page.path), props.setOpenDrawer(false));
              }}
            >
              <ListItemIcon>{React.createElement(page.icon)}</ListItemIcon>
              <ListItemText primary={page.name} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};
